import { toast } from 'react-toastify'
import get from 'lodash.get'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import request from 'superagent'

import Auction from '../../models/auction.model'
import imageModel from '../../models/image.model'

import APIRequest from '../../helpers/apiHelpers'
import authHelpers from '../../helpers/authHelpers'
import { decodeEntities, translate } from '../../helpers/stringHelpers'
import { formatCurrency } from '../../helpers/currencyHelpers'
import { calculate } from '../helpers/creditLimitHelpers'
import { getListingInfo } from '../helpers/listingHelpers'
import { parseJsonContent } from '../helpers/descriptionHelpers'

import webcastStatuses from '../../constants/webcastStatuses'
import listingChoices from '../../constants/listingChoices'

// import * as Sentry from '@sentry/react'

const decodeLegacyAuction = (auction) =>
  Object.assign({}, auction, {
    typeMessage: decodeEntities(auction.typeMessage),
    endsOrStarts: decodeEntities(auction.endsOrStarts),
    auctionStartTimeString: decodeEntities(auction.auctionStartTimeString),
    title: decodeEntities(auction.title),
    description: decodeEntities(auction.description),
    location: decodeEntities(auction.location)
  })

const parseBid = (bid, isWebcast) =>
  isWebcast
    ? Object.assign({}, bid, {
      amount: bid.amount / 100
    })
    : bid

const parseMaxBid = (maxBid, isWebcast) =>
  isWebcast
    ? Object.assign({}, maxBid, {
      value: maxBid.value / 100
    })
    : maxBid

const parseSale = (sale, isWebcast) =>
  isWebcast
    ? Object.assign({}, sale, {
      incrementValue: sale.incrementValue / 100,
      nextBidValue: sale.nextBidValue / 100
    })
    : sale

// const parseSaleV2 = (state, currentBidValue, sale, isWebcast) => {
//   return isWebcast
//     ? Object.assign({}, sale, {
//       incrementValue: sale.incrementValue / 100,
//       nextBidValue: sale.nextBidValue / 100
//     })
//     : Object.assign({}, sale,
//       customIncrements(state, currentBidValue, sale)
//     )
// }

// const customIncrements = (state, currentBidValue, sale) => {
//   const auctionUuid = state.lots.listings[sale.listingUuid]?.auctionUuid
//   const increments = state.listingSales.incrementTables?.[auctionUuid]?.[sale.listingUuid] || state.listingSales.incrementTables?.[auctionUuid]?.[0] || state.listingSales.incrementTables?.[0]
//   let incrementValue = sale.incrementValue
//   let nextBidValue = sale.nextBidValue

//   if (increments) {
//     // divide by 100, due to it always being in pence
//     for (const key in increments) {
//       if (currentBidValue < (key / 100)) {
//         incrementValue = increments[key] / 100
//         nextBidValue = currentBidValue + incrementValue
//         break
//       }
//     }
//     if (incrementValue === null || nextBidValue === null) {
//       if ('0' in increments) {
//         incrementValue = increments['0'] / 100
//         nextBidValue = currentBidValue + incrementValue
//       }
//     }
//     // show opening bid amount
//     if (!sale.bids.length) {
//       nextBidValue = sale.nextBidValue
//     }
//   }
//   console.log('>>> incrementValue ! ', incrementValue, nextBidValue)
//   return {
//     incrementValue: incrementValue,
//     nextBidValue: nextBidValue
//   }
// }

const getVisibleNotifications = (notifications) =>
  notifications?.filter((notification) => notification.visible === true)

const getPurchaseSuccessMessage = (purchaseTypeId, isMarketplace) => {
  switch (purchaseTypeId) {
    case 2:
      return isMarketplace
        ? 'JspPublicCodes_JSP_MARKETPLACE_OFFER_APPROVED'
        : 'JspPublicCodes_JSP_LISTING_OFFER_APPROVED'
    case 3:
      return 'JspPublicCodes_JSP_LISTING_BUY_SUCCESSFUL'
    default:
      return ''
  }
}

const recentAddedMap = new Map()
const recentRemovedMap = new Map()
// const recentAddedMapBP = new Map()
// const recentRemovedMapBP = new Map()
const recentBidEvents = new Map()
const ADD_EXPIRY_MS = 5000 // 5 second

const auctions = {
  historicGet: () => {
    return (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config
      dispatch({
        type: 'AUCTIONS_HISTORIC_GET'
      })
      return APIRequest.get(apiBase, clientId, 'auctionsArchived')
        .then((res) => {
          const fetchedAuctions = res.body.basicAuctionBidJSModelList.map(
            (auctionModel) => new Auction(auctionModel).toJSON()
          )
          return dispatch({
            type: 'AUCTIONS_HISTORIC_GET_SUCCESS',
            auctions: fetchedAuctions,
            fetchedAt: Date.now()
          })
        })
        .catch((err) => {
          console.error(err)
          dispatch({
            type: 'AUCTIONS_HISTORIC_GET_FAILED',
            err
          })
          throw err
        })
    }
  },
  historicSearch: (term) => async (dispatch) =>
    dispatch({
      type: 'AUCTIONS_HISTORIC_SEARCH',
      term
    }),
  listDeprecated: (uid) => {
    return (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config
      dispatch({
        type: 'AUCTIONS_DEPRECATED_GET'
      })
      return APIRequest.get(apiBase, clientId, 'home', `uid=${uid}`)
        .then((res) => {
          const upcoming = get(
            res?.body,
            'models.HomePageModel.upcomingModel',
            {}
          )
          return dispatch({
            type: 'AUCTIONS_DEPRECATED_GET_SUCCESS',
            auctions: upcoming.upcomingAuctions.map(decodeLegacyAuction),
            countries: upcoming.countries,
            featuredAuctions:
              upcoming.upcomingFeaturedAuctions.map(decodeLegacyAuction),
            marketplaceCategories: upcoming.upcomingMarketplace
              ? upcoming.upcomingMarketplace.map((marketplaceCategory) =>
                Object.assign({}, marketplaceCategory, {
                  parentCategoryName: decodeEntities(
                    marketplaceCategory.parentCategoryName
                  )
                })
              )
              : [],
            registeredAuctions: get(
              res?.body,
              'models.HomePageModel.upcomingModel.registeredFor',
              {}
            )
          })
        })
        .catch((err) => {
          console.error(err)
          dispatch({
            type: 'AUCTIONS_DEPRECATED_GET_FAILED',
            err
          })
          throw err
        })
    }
  },
  onWebsocketEvent: (event, locale, userUuid = null) => {
    return (dispatch, getState) => {
      dispatch({
        type: 'WEBSOCKET_EVENT',
        event
      })

      const timestamp = event.timestamp
      const auctionUuid = get(event, 'data.auctionUuid')
      const auction =
        auctionUuid &&
        (get(getState(), `auctions.auctions.${event.data.auctionUuid}`) ||
          get(getState(), 'auctions.auctions.marketplace'))
      const isWebcast = auction?.webcast
      const marketplaceFriendlyAuctionUuid = auction?.uuid
      const isMarketplace = marketplaceFriendlyAuctionUuid === 'marketplace'
      const listings = get(event, '.data.listings')
      const creditLimit = getState().creditLimit
      const creditLimitBids = { ...creditLimit.bids }
      const creditLimitMaxBids = { ...creditLimit.maxBids }
      const creditLimitSoldLots = { ...creditLimit.soldLots }

      try {
        switch (event.type) {
          case 'SUBSCRIBE_TO_AUCTION':
            dispatch({
              type: 'SUBSCRIBE_TO_AUCTION'
            })
            break
          case 'AUCTION_SUBSCRIBED': {
            dispatch({
              type: 'AUCTION_SUBSCRIBED_SUCCESS'
            })

            const activeListings = Object.values(getState()?.saleStatuses?.saleStatuses || {}).filter((saleStatus) => {
              return saleStatus.endsAt > Date.now()
            }).map((saleStatus) => saleStatus.listingUuid)
            dispatch({
              type: 'LISTING_SALE_ACTIVE_LISTINGS_INITIALISE',
              listingUuids: activeListings
            })

            break
          }
          case 'AUCTION_UPDATED':
          case 'WEBCAST_STARTED':
            dispatch({
              type: 'AUCTION_GET_SUCCESS',
              auction: Object.assign({}, event.data.auction, {
                uuid: isMarketplace ? 'marketplace' : auctionUuid,
                activeListings: event.data.auction.activeListings.filter(listingUuid => listings?.[listingUuid]?.lotNumber !== '0')
              })
            })
            break
          case 'BID_PLACED': {
            const isHighestBidMatchingTheCurrentBid = event.data.saleStatus.highestBidUuid === event.data.bid.uuid
            const listingUuid = event.data.sale.listingUuid
            const isAutobid = event.data.bid?.autobid
            const previousSaleStatus = getState().saleStatuses.saleStatuses[listingUuid]
            const previousBid = previousSaleStatus && getState().bids.bids[previousSaleStatus.highestBidUuid]
            // const isBidInTable = !!event.data.sale.bids.includes(event.data.bid.uuid) && isAutobid

            if (userUuid) {
              const oAuthConfig = getState().config.input.options.oAuth
              const tokenName = oAuthConfig.tokenName
              const thirdPartyToken = authHelpers.getCookie(tokenName)
              const listing = getState().lots.listings[listingUuid]
              const maxBid = getState().maxBids.maxBidsByListingUuid[listingUuid]
              const auctionId = getState().auctions.auctions[auctionUuid].id
              const prevRegistrantUuid = getState().registrations.registrantIdsByUserUuidByAuction[auctionUuid]?.[previousBid?.userUuid]?.uuid
              const isUserPreviousHighBidder = previousBid?.userUuid === userUuid
              const isEventNewer = timestamp >= previousBid?.timestamp
              // autobid placed by user which outbids previous bidder
              const newBidAmount = event.data.bid.amount
              const userHasHigherMaxBid = maxBid?.userUuid === userUuid && maxBid.value >= newBidAmount
              const autoBidOutbid = isAutobid && userHasHigherMaxBid
              const sameUser = userUuid === event.data.bid.userUuid
              // const latestBidAmount = getState().bids.bids[event.data.saleStatus?.highestBidUuid]?.amount || 0
              const placedAt = event.data.bid.placedAt
              // Check if there is already an event for the same listingUuid and placedAt
              const existingEvent = recentBidEvents.get(`${listingUuid}-${placedAt}`)
              const bidAmount = event.data?.bid?.amount
              let doProcessStoredEvent = false

              if (existingEvent) {
                // Compare the current event with the existing event
                if (bidAmount > existingEvent.amount) {
                  recentBidEvents.set(`${listingUuid}-${placedAt}`, { ...event.data.bid })
                } else {
                  doProcessStoredEvent = true
                }
              } else {
                // No existing event, store the current event
                if (!event.data.bid.cancelled) {
                  recentBidEvents.set(`${listingUuid}-${placedAt}`, { ...event.data.bid })
                }
              }
              // * ~~ # is a bidder ~~
              // * #1 Bid on #2 Bid
              // * #1 Bid on #1 Bid
              // * #1 Bid on #2 Autobid won
              // * #1 Bid on #2 Autobid lost
              // * #1 Autobid on #2 Bid
              // * #1 Autobid on #2 Autobid (by 2 or more increments)
              // * #1 Autobid on #2 Autobid (by 1 increment)
              // * #1 Autobid on #2 Autobid (same autobid amount)
              // * #1 Autobid on #1 Autobid
              // * #1 Direct Bid on #2 Bid
              // * #1 Direct Bid on #2 Autobid
              // * #1 Direct Bid on #2 Direct Bid

              if (!doProcessStoredEvent) {
                // Process the event after a short delay to ensure all related events are received
                setTimeout(() => {
                  const storedEvent = recentBidEvents.get(`${listingUuid}-${placedAt}`)
                  if (storedEvent) {
                    const creditLimit = getState().creditLimit
                    const creditLimitBids = { ...creditLimit.bids }
                    const creditLimitMaxBids = { ...creditLimit.maxBids }
                    let clModifier = 0
                    if (storedEvent.userUuid === userUuid) {
                      if (storedEvent.autobid) {
                        const maxBid = getState().maxBids.maxBidsByListingUuid[listingUuid]
                        creditLimitMaxBids[listingUuid] = maxBid.value
                      }
                      // if normal bid reaches max bid, remove it
                      if (creditLimitMaxBids?.[listingUuid] === storedEvent.amount) {
                        delete creditLimitMaxBids[listingUuid]
                      }
                      creditLimitBids[listingUuid] = storedEvent.amount
                      clModifier = storedEvent.amount
                    } else {
                      delete creditLimitBids[listingUuid]
                      delete creditLimitMaxBids[listingUuid]
                    }

                    const { maxBidSpend } = calculate(
                      { ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids },
                      listingUuid,
                      clModifier
                    )

                    dispatch({
                      type: 'USER_SPENDING_LIMIT_SUCCESS',
                      session: {
                        biddingStatus: creditLimit.biddingStatus,
                        maxSpend: creditLimit.maxSpend,
                        currentSpend: maxBidSpend
                      },
                      bids: creditLimitBids,
                      maxBids: creditLimitMaxBids
                    })

                    // Remove the processed event from the Map
                    recentBidEvents.delete(`${listingUuid}-${placedAt}`)
                  }
                }, 1000)
              }

              if (previousBid && sameUser && !isUserPreviousHighBidder && (!isAutobid || autoBidOutbid) && isHighestBidMatchingTheCurrentBid) {
                request.post(`${oAuthConfig.ssoLoginUrl}/notification?t=${timestamp}`)
                  .set('Authorization', `Bearer ${thirdPartyToken}`)
                  .set('Content-Type', 'application/json')
                  .send({
                    auctionId: auctionId,
                    listingId: listing.id,
                    lotNumber: listing.lotNumber,
                    registrantUuid: prevRegistrantUuid,
                    prevBidAmount: previousBid?.amount
                  })
                  .then(async (response) => {
                    if (response.status !== 200) {
                      console.error(response.body)
                    }
                    if (process.env.NODE_ENV !== 'production') {
                      if (response.status === 200) {
                        toast.success(response.body.test)
                      } else {
                        toast.error(response.body.message)
                      }
                    }
                    return response.body
                  }).catch(err => console.error(err))
              }

              if (
                previousBid &&
                isEventNewer &&
                ((isHighestBidMatchingTheCurrentBid &&
                  isUserPreviousHighBidder &&
                  !sameUser) ||
                  (!isHighestBidMatchingTheCurrentBid && sameUser)) &&
                !userHasHigherMaxBid
              ) {
                toast.warning(
                  translate(
                    isMarketplace
                      ? 'JspPublicCodes_JSP_MARKETPLACE_BID_OUTBID'
                      : 'JspPublicCodes_JSP_LISTING_BID_OUTBID'
                  ).replace(
                    '{0}',
                    isMarketplace ? listing.id : listing.lotNumber
                  )
                )
              }

              // const autoBidOutbid = isAutobid && userHasHigherMaxBid
              // console.log('>>>>>>>>>>>>>>>>>>>>>> ---------- bid:', {
              //   newBidAmount,
              //   latestBidAmount,
              //   autoBidOutbid,
              //   userHasHigherMaxBid,
              //   isAutobid,
              //   sameUser,
              //   isHighestBidMatchingTheCurrentBid,
              //   credit: { ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids }
              // })

              // trigger CREDIT calculation for autobid value update
              // if (userUuid === event.data.bid.userUuid && isAutobid) {
              // In this scenario we update the bid value for the winning autobidder, the autobid value stays the same
              // * ! Checking prevous bid with new bid to avoid out-of-order events
              // * This seems to only happen when an Autobid outbids another Autobid
              // * The belated event has the lower bid amount
              // * If the socket event is out-of-order the previous bid will be higher than the bid amount of the belated event
            }

            // bid
            dispatch({
              type: 'BID_GET_SUCCESS',
              bid: parseBid(event.data.bid, isWebcast),
              timestamp
            })

            // sale
            dispatch({
              type: 'LISTING_SALE_GET_SUCCESS',
              sale: parseSale(event.data.sale, isWebcast),
              // sale: parseSaleV2(
              //   getState(),
              //   event.data.bid.amount,
              //   event.data.sale,
              //   isWebcast
              // ),
              timestamp
            })

            // saleStatus
            if (isHighestBidMatchingTheCurrentBid) {
              dispatch({
                type: 'SALE_STATUS_GET_SUCCESS',
                saleStatus: event.data.saleStatus,
                timestamp
              })
            }

            // warning
            dispatch({
              type: 'WEBCAST_WARNING_RESET'
            })
            break
          }
          case 'BID_CANCELLED':
          case 'BID_REINSTATED': {
            // bid
            dispatch({
              type: 'BID_GET_SUCCESS',
              bid: parseBid(event.data.bid, isWebcast),
              timestamp
            })

            // trigger CREDIT calculation
            const listingUuid = event.data.sale.listingUuid
            const bids = getState().bids.bids
            // const newBidAmount = event.data.bid.amount
            // const bidValue = get(creditLimit, `bids.${listingUuid}`, 0)
            // const maxBidValue = get(creditLimit, `maxBids.${listingUuid}`, 0)
            // const higherBidValue = bidValue > maxBidValue ? bidValue : maxBidValue
            const listingBids = getState().listingSales.sales?.[listingUuid]?.bids
            let lastBid = null

            if (listingBids) {
              const validBids = Object.values(listingBids)
                .map(uuid => bids[uuid])
                .filter(bid => bid && !bid.cancelled) // Filter out cancelled bids
              // Sort bids by `placedAt` timestamp in descending order
              validBids.sort((a, b) => b.placedAt - a.placedAt)
              // Get the last bid (most recent one)
              lastBid = validBids[0] || null
            }

            // If the cancelled bid is the user's bid, update the credit limit
            if (userUuid === event.data.bid.userUuid && userUuid !== lastBid?.userUuid) {
              delete creditLimitBids[listingUuid]
              delete creditLimitMaxBids[listingUuid]

              const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids }, listingUuid, 0)
              dispatch({
                type: 'USER_SPENDING_LIMIT_SUCCESS',
                session: {
                  biddingStatus: creditLimit.biddingStatus,
                  maxSpend: creditLimit.maxSpend,
                  currentSpend: maxBidSpend
                  // currentSpend: creditLimit.currentSpend - higherBidValue
                },
                bids: creditLimitBids,
                maxBids: creditLimitMaxBids,
                soldLots: creditLimitSoldLots
              })
            }

            // If the next highest bid is the user's bid, ADD to the credit limit
            if (userUuid === lastBid?.userUuid) {
              creditLimitBids[listingUuid] = lastBid.amount
              const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids }, listingUuid, 0)

              dispatch({
                type: 'USER_SPENDING_LIMIT_SUCCESS',
                session: {
                  biddingStatus: creditLimit.biddingStatus,
                  maxSpend: creditLimit.maxSpend,
                  currentSpend: maxBidSpend
                  // currentSpend: creditLimit.currentSpend - event.data.bid.amount + lastBid.amount
                },
                bids: creditLimitBids,
                maxBids: creditLimitMaxBids,
                soldLots: creditLimitSoldLots
              })
            }

            // Recalculate the Next Bid Value using the previous bid
            // const saleObject = parseSaleV2(
            //   getState(),
            //   lastBid?.amount,
            //   event.data.sale,
            //   isWebcast
            // )
            // saleObject.nextBidValue = lastBid?.amount ? saleObject.nextBidValue : event.data.sale.nextBidValue
            // sale
            dispatch({
              type: 'LISTING_SALE_GET_SUCCESS',
              sale: parseSale(event.data.sale, isWebcast),
              // sale: saleObject,
              timestamp
            })

            // saleStatus
            dispatch({
              type: 'SALE_STATUS_GET_SUCCESS',
              saleStatus: event.data.saleStatus,
              timestamp
            })

            // warning
            dispatch({
              type: 'WEBCAST_WARNING_RESET'
            })
            break
          }
          case 'REGISTRANT_UPDATED':
            // registrants
            dispatch({
              type: 'REGISTRANT_GET_SUCCESS',
              auctionUuid: event.data.auctionUuid,
              registrant: event.data.registrant,
              timestamp
            })
            break

          case 'SALE_COMPLETED':
          case 'SALE_STARTED':

            if (event.type === 'SALE_STARTED') {
              const listingUuids = []
              for (const listingUuid in event.data.saleStatuses) {
                listingUuids.push(listingUuid)
              }
              dispatch({
                type: 'LISTING_SALE_ADD_ACTIVE_LISTINGS',
                listingUuids
              })
            }

            if (event.type === 'SALE_COMPLETED') {
              const listingUuids = []
              for (const listingUuid in event.data.saleStatuses) {
                listingUuids.push(listingUuid)
              }
              dispatch({
                type: 'LISTING_SALE_REMOVE_ACTIVE_LISTINGS',
                listingUuids
              })
            }

            if (userUuid) {
              for (const listingUuid in event.data.saleStatuses) {
                const saleStatus = event.data.saleStatuses[listingUuid]
                const sold = saleStatus.sold
                const webcastStateId = saleStatus?.webcastStateId
                const highestBidUuid = saleStatus?.highestBidUuid
                const highestOfferUuid = saleStatus?.highestOfferUuid
                const sale = event.data.sales?.[listingUuid]
                const listing = getState().lots.listings?.[listingUuid]
                const offer = getState().offers.offers?.[highestOfferUuid]
                const bids = getState().bids.bids
                const bid = getState().bids.bids?.[highestBidUuid]
                const highestBid = highestBidUuid ? bids?.[highestBidUuid] : null
                const maxBid = getState().maxBids.maxBidsByListingUuid?.[listingUuid]
                const notifications = getState().notifications
                const isUserOfferer = offer?.userUuid === userUuid
                const isUserBidder = bid?.userUuid === userUuid
                const newBidAmount = bid?.amount
                const {
                  isPassedIn,
                  // isSold,
                  isSoftSold,
                  // isPassedInSale,
                  // isSoftPassedIn,
                  hasEnded,
                  isWithdrawn
                } = getListingInfo(listing, listing?.specs, saleStatus, bids, sale, listing?.type === 'lot')

                // recalculate credit limit on max bids that didn't reach reserve
                if (userUuid === bid?.userUuid) {
                  // if lot is not sold
                  if (event.type === 'SALE_COMPLETED' && !isSoftSold) {
                    delete creditLimitSoldLots?.[listingUuid]
                  }

                  // ! this is to return back the CL to normal after it gets emptied on sold lots
                  // if (!isSold && !isPassedIn && !isWithdrawn && userUuid === highestBid?.userUuid) {
                  if (!hasEnded && !isPassedIn && !isWithdrawn && userUuid === highestBid?.userUuid) {
                    creditLimit.bids[listingUuid] = newBidAmount
                    // override highest bid if max bid is higher
                    // if (!isSoftSold && !hasEnded && maxBid?.userUuid === userUuid && maxBid?.value > highestBid?.amount) {
                    if (maxBid?.userUuid === userUuid && maxBid?.value > highestBid?.amount) {
                      creditLimitMaxBids[listingUuid] = maxBid.value
                    }
                  }

                  const maxBidAmount = creditLimit.maxBids?.[listingUuid] || 0
                  const bidAmount = creditLimit.bids?.[listingUuid] || 0

                  // if final bid is less than max bid, remove it from credit limit
                  if (bidAmount === newBidAmount && maxBidAmount > newBidAmount) {
                    delete creditLimitMaxBids[listingUuid]
                    const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids }, listingUuid, newBidAmount)
                    dispatch({
                      type: 'USER_SPENDING_LIMIT_SUCCESS',
                      session: {
                        biddingStatus: creditLimit.biddingStatus,
                        maxSpend: creditLimit.maxSpend,
                        currentSpend: maxBidSpend
                      },
                      bids: creditLimitBids,
                      maxBids: creditLimitMaxBids,
                      soldLots: creditLimitSoldLots
                    })
                  }

                  // if lot is passed in, remove it from credit limit
                  if (isPassedIn && (bidAmount || maxBidAmount)) {
                    delete creditLimitBids[listingUuid]
                    delete creditLimitMaxBids[listingUuid]

                    const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids }, null, newBidAmount)

                    dispatch({
                      type: 'USER_SPENDING_LIMIT_SUCCESS',
                      session: {
                        biddingStatus: creditLimit.biddingStatus,
                        maxSpend: creditLimit.maxSpend,
                        currentSpend: maxBidSpend
                      },
                      bids: creditLimitBids,
                      maxBids: creditLimitMaxBids,
                      soldLots: creditLimitSoldLots
                    })
                  }

                  if (isSoftSold) {
                    // delete creditLimitBids?.[listingUuid]
                    delete creditLimitMaxBids?.[listingUuid]
                    creditLimitSoldLots[listingUuid] = newBidAmount
                    const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids }, listingUuid, newBidAmount)

                    dispatch({
                      type: 'USER_SPENDING_LIMIT_SUCCESS',
                      session: {
                        biddingStatus: creditLimit.biddingStatus,
                        maxSpend: creditLimit.maxSpend,
                        currentSpend: maxBidSpend
                      },
                      bids: creditLimitBids,
                      maxBids: creditLimitMaxBids,
                      soldLots: creditLimitSoldLots
                    })
                  }
                }

                if (sold && sale) {
                  if (isUserOfferer && highestOfferUuid) {
                    dispatch({
                      type: 'AUCTION_NOTIFICATION_ADDED',
                      auctionUuid: marketplaceFriendlyAuctionUuid,
                      listingUuid,
                      message: translate(
                        getPurchaseSuccessMessage(
                          sale.purchaseTypeId,
                          isMarketplace
                        )
                      )
                        .replace(
                          '{0}',
                          formatCurrency(
                            locale,
                            sale.currencyCode,
                            offer.amount
                          )
                        )
                        .replace(
                          '{1}',
                          isMarketplace ? listing?.id : listing?.lotNumber
                        ),
                      notificationType: 'success'
                    })
                  }
                  if (
                    isUserBidder &&
                    highestBidUuid &&
                    webcastStateId === webcastStatuses.INPLAY_ENDED_WITH_CHOICES
                  ) {
                    dispatch({
                      type: 'INTERACTIVE_NOTIFICATION_ADDED',
                      listingUuid,
                      notificationType: listingChoices[listing.choiceId - 1]
                    })
                  }
                }
                if (!sold && isUserBidder && highestBidUuid) {
                  const storedInteractiveNotifications = JSON.parse(
                    localStorage.getItem('interactiveNotifications')
                  )

                  if (storedInteractiveNotifications) {
                    notifications.interactive.push(
                      ...storedInteractiveNotifications
                    )
                  }
                  const hasInteractiveNotification = getVisibleNotifications(
                    notifications.interactive
                  ).some(
                    (notification) => notification.listingUuid === listingUuid
                  )
                  if (hasInteractiveNotification) {
                    dispatch({
                      type: 'INTERACTIVE_NOTIFICATION_REMOVED'
                    })
                    if (
                      getVisibleNotifications(notifications.global).length === 0
                    ) {
                      dispatch({
                        type: 'GLOBAL_NOTIFICATION_ADDED',
                        notificationType: 'info',
                        icon: faCircleExclamation,
                        message: translate(
                          'JspPublicCodes_JSP_WEBCAST_CHOICE_UNDONE'
                        )
                      })
                    }
                  }
                }
              }
            }
            // saleStatus
            dispatch({
              type: 'SALE_STATUSES_GET_SUCCESS',
              saleStatuses: event.data.saleStatuses,
              timestamp
            })
            if (event.data.inPlay) {
              // webcastInPlay
              dispatch({
                type: 'WEBCAST_INPLAY_GET_SUCCESS',
                inPlay: event.data.inPlay,
                timestamp
              })
            }
            if (event.data.sales) {
              if (isWebcast) {
                for (const sale in event.data.sales) {
                  if (
                    Object.prototype.hasOwnProperty.call(event.data.sales, sale)
                  ) {
                    // event.data.sales[sale] = parseSaleV2(
                    //   getState(),
                    //   event.data.bid.amount,
                    //   event.data.sales[sale],
                    //   isWebcast
                    // )
                    event.data.sales[sale] = parseSale(
                      event.data.sales[sale],
                      isWebcast
                    )
                  }
                }
              }
              // webcastInPlay
              dispatch({
                type: 'LISTING_SALES_GET_SUCCESS',
                sales: event.data.sales,
                timestamp
              })
            }
            break

          case 'SALE_UNITS_BIDDING_TYPE_SET':
            // sale
            dispatch({
              type: 'LISTING_SALE_GET_SUCCESS',
              sale: parseSale(event.data.sale, isWebcast),
              // sale: parseSaleV2(
              //   getState(),
              //   event.data.bid.amount,
              //   event.data.sale,
              //   isWebcast
              // ),
              timestamp
            })
            // saleStatus
            dispatch({
              type: 'SALE_STATUS_GET_SUCCESS',
              saleStatus: event.data.saleStatus,
              timestamp
            })
            break

          case 'SALE_WITHDRAWN': {
            // auction
            dispatch({
              type: 'AUCTION_LISTINGS_REMOVE_SUCCESS',
              auctionUuid: marketplaceFriendlyAuctionUuid,
              listingUuids: Object.keys(event.data.sales),
              listings: getState().lots.listings,
              timestamp
            })

            const listingUuid = Object.keys(event.data.sales)[0]
            // ! remove after testing
            // const listings = getState().lots.listings
            // const listing = listings[listingUuid]

            // * Handling out-of-order SALE_WITHDRAWN events
            recentRemovedMap.set(listingUuid, Date.now())
            setTimeout(() => {
              recentRemovedMap.delete(listingUuid)
            }, ADD_EXPIRY_MS)

            const processOutOfOrderEvent = Object.keys(event.data.listings).some(itemUuid => {
              const addedTimestamp = recentAddedMap.get(itemUuid)
              recentAddedMap.delete(itemUuid)
              return addedTimestamp && addedTimestamp <= timestamp
            })

            // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
            //   console.log('>>>>! checking SALE_WITHDRAWN processOutOfOrderEvent:', { processOutOfOrderEvent, listingUuid, recentAddedMap })
            // }
            if (processOutOfOrderEvent) {
              // setPreview = false
              if (creditLimitBids?.[listingUuid] || creditLimitMaxBids?.[listingUuid] || creditLimitSoldLots?.[listingUuid]) {
                delete creditLimitBids?.[listingUuid]
                delete creditLimitMaxBids?.[listingUuid]
                delete creditLimitSoldLots?.[listingUuid]
                const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids, soldLots: creditLimitSoldLots }, null, 0)
                // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
                //   console.log('>>>! Case 3 (losing): Lot withdrawn, updating credit limit!')
                // }
                // console.log('>>> Case 3 (losing): Lot withdrawn, updating credit limit!', listing.lotNumber)
                dispatch({
                  type: 'USER_SPENDING_LIMIT_SUCCESS',
                  session: {
                    biddingStatus: creditLimit.biddingStatus,
                    maxSpend: creditLimit.maxSpend,
                    currentSpend: maxBidSpend
                  },
                  bids: creditLimitBids,
                  maxBids: creditLimitMaxBids,
                  soldLots: creditLimitSoldLots
                })
              }
            }

            const updatedSaleStatuses = Object.fromEntries(
              Object.entries(event.data.saleStatuses).map(([key, value]) => [
                key,
                { ...value }
                // { ...value, preview: setPreview }
              ])
            )

            dispatch({
              type: 'SALE_STATUSES_GET_SUCCESS',
              saleStatuses: updatedSaleStatuses,
              timestamp
            })

            const interactiveNotifications =
              getState().notifications.interactive

            const storedInteractiveNotifications = JSON.parse(
              localStorage.getItem('interactiveNotifications')
            )

            const visibleInteractiveNotifications = getVisibleNotifications(
              interactiveNotifications
            )
            const visibleStoredInteractiveNotifications = getVisibleNotifications(
              storedInteractiveNotifications
            )
            if (
              visibleInteractiveNotifications.length ||
              visibleStoredInteractiveNotifications?.length
            ) {
              dispatch({
                type: 'INTERACTIVE_NOTIFICATION_REMOVED'
              })
              dispatch({
                type: 'GLOBAL_NOTIFICATION_ADDED',
                notificationType: 'info',
                icon: faCircleExclamation,
                message: translate(
                  'JspPublicCodes_JSP_WEBCAST_CHOICE_MADE_BY_AUCTIONEER'
                )
              })
            }
            break
          }
          case 'SALE_ADDED': {
            const listingUuid = Object.keys(event.data.sales)[0]
            const maxBid = getState().maxBids.maxBidsByListingUuid[listingUuid]
            const saleStatus = event.data.saleStatuses?.[listingUuid]
            const latestBid = getState().bids.bids?.[saleStatus?.highestBidUuid]
            const listing = event.data.listings?.[listingUuid]
            // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
            //   console.log('>>>>!', event.data, event.data.listings, listing)
            // }
            if (latestBid?.userUuid === userUuid || maxBid?.userUuid === userUuid) {
              const sale = event.data.sales[listingUuid]
              const bids = getState().bids.bids
              const specs = parseJsonContent(listing?.description) || {}
              const { isSoftSold, hasEnded, isWithdrawn } = getListingInfo(listing, specs, saleStatus, bids, sale, listing?.type === 'lot')
              // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
              //   console.log('>>>! SALE_ADDED processing credit limit update:', { specs, isWithdrawn, listingUuid })
              // }
              if (!hasEnded || !isSoftSold) {
                delete creditLimitSoldLots[listingUuid]
              }

              if (latestBid?.userUuid === userUuid) {
                creditLimitBids[listingUuid] = latestBid?.amount || 0
              }

              if (isWithdrawn) {
                // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
                //   console.log('>>>!!! test withdrawn on added', listing.lotNumber)
                // }
                delete creditLimitBids?.[listingUuid]
                delete creditLimitMaxBids?.[listingUuid]
                delete creditLimitSoldLots?.[listingUuid]
              } else if (isSoftSold && latestBid?.userUuid === userUuid) {
                creditLimitSoldLots[listingUuid] = latestBid?.amount || 0
                // console.log('>>>!!! test soft sold on added', listing.lotNumber, creditLimitBids?.[listingUuid], creditLimitMaxBids?.[listingUuid])
                delete creditLimitMaxBids?.[listingUuid]
                // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
                //   console.log('>>>!!! test soft sold on added', listing.lotNumber)
                // }
              } else if (!hasEnded && maxBid?.userUuid === userUuid && maxBid?.value > latestBid?.amount) {
                creditLimitMaxBids[listingUuid] = maxBid.value
                // delete creditLimitSoldLots[listingUuid]
                // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
                //   console.log('>>>!!! test re-instated on added', listing.lotNumber)
                // }
              } else if (hasEnded && !isSoftSold) {
                delete creditLimitMaxBids?.[listingUuid]
                delete creditLimitBids?.[listingUuid]
                // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
                //   console.log('>>>!!! test ended not sold on added', listing.lotNumber)
                // }
              }
              const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids, soldLots: creditLimitSoldLots }, listingUuid, 0)

              // if (['67', '68', '69', '70'].includes(listing.lotNumber)) {
              //   console.log('>>>! Case 3 (winning): Lot re-instated, updating credit limit!', listing.lotNumber, creditLimitBids)
              // }
              // console.log('>>> Case 3 (winning): Lot re-instated, updating credit limit!', listing.lotNumber)

              dispatch({
                type: 'USER_SPENDING_LIMIT_SUCCESS',
                session: {
                  biddingStatus: creditLimit.biddingStatus,
                  maxSpend: creditLimit.maxSpend,
                  currentSpend: maxBidSpend
                },
                bids: creditLimitBids,
                maxBids: creditLimitMaxBids,
                soldLots: creditLimitSoldLots
              })
            }

            Object.keys(event.data.listings).forEach(itemUuid => {
              // ! ISSUE:
              // During the sync, SALE_ADDED should run AFTER the SALE_WITHDRAWN, however it sometimes runs first, which causes the SALE_WITHDRAWN to remove the lot that was just added back in.
              // * SOLUTION:
              // Store timestamp in a map, and check against it in the SALE_WITHDRAWN event.
              // If the timestamp in the map is less than the SALE_WITHDRAWN event timestamp, treat SALE_WITHDRAWN as out of order and ignore it.
              // If the timestamp in the map is greater than the SALE_WITHDRAWN event timestamp, process as normal

              // * (1) We add the lot to the map with an expiry time
              recentAddedMap.set(itemUuid, timestamp + ADD_EXPIRY_MS)
              // ! ISSUE:
              // If SALE_ADDED runs in normal order (2nd), then item in the Map will not be removed and the lot will disappear from CL after expiry time, which is not the intended behaviour.

              // * (2) Set the timer to remove the lot from the map after expiry time
              // * (3) If SALE_WITHDRAWN runs after the expiry time, then the map listing is gone and CL is processed in this timer function above
              setTimeout(() => {
                // ! SALE_WITHDRAWN out of order handling
                // This code block acts as an Alias for SALE_WITHDRAWN during out of order events. It removes the lot from CL if the lot was removed for longer than the expiry time.
                if (recentAddedMap.has(itemUuid) && recentRemovedMap.has(itemUuid)) {
                  delete creditLimitBids?.[listingUuid]
                  delete creditLimitMaxBids?.[listingUuid]
                  delete creditLimitSoldLots?.[listingUuid]
                  console.log('>>>! Case 4 (losing): Lot withdrawn (out of order), updating credit limit!', listing.lotNumber)
                  const { maxBidSpend } = calculate({ ...creditLimit, bids: creditLimitBids, maxBids: creditLimitMaxBids, soldLots: creditLimitSoldLots }, null, 0)
                  dispatch({
                    type: 'USER_SPENDING_LIMIT_SUCCESS',
                    session: {
                      biddingStatus: creditLimit.biddingStatus,
                      maxSpend: creditLimit.maxSpend,
                      currentSpend: maxBidSpend
                    },
                    bids: creditLimitBids,
                    maxBids: creditLimitMaxBids,
                    soldLots: creditLimitSoldLots
                  })
                }

                // if item is still in the map after expiry time, remove it
                recentAddedMap.delete(itemUuid)
              }, ADD_EXPIRY_MS)

              // * (4) If SALE_WITHDRAWN runs right after SALE_ADDED, then the map listing is removed and CL is processed in the SALE_WITHDRAWN event
            })

            if (isWebcast) {
              for (const sale in event.data.sales) {
                if (
                  Object.prototype.hasOwnProperty.call(event.data.sales, sale)
                ) {
                  // event.data.sales[sale] = parseSaleV2(
                  //   getState(),
                  //   event.data.bid.amount,
                  //   event.data.sales[sale],
                  //   isWebcast
                  // )
                  event.data.sales[sale] = parseSale(
                    event.data.sales[sale],
                    isWebcast
                  )
                }
              }
            }
            // sale
            dispatch({
              type: 'LISTING_SALES_GET_SUCCESS',
              sales: event.data.sales,
              timestamp
            })
            // saleStatus
            dispatch({
              type: 'SALE_STATUSES_GET_SUCCESS',
              saleStatuses: event.data.saleStatuses,
              timestamp
            })
            // lot
            dispatch({
              type: 'LISTINGS_GET_SUCCESS',
              listings: event.data.listings,
              isMarketplace,
              timestamp
            })
            // auction
            dispatch({
              type: 'AUCTION_LISTINGS_ADD_SUCCESS',
              auctionUuid: marketplaceFriendlyAuctionUuid,
              listingUuids: Object.keys(event.data.sales),
              listings: getState().lots.listings,
              timestamp
            })
            // image
            const transformedImages = {}
            const images = event.data.attachments
            for (const image in images) {
              if (Object.prototype.hasOwnProperty.call(images, image)) {
                transformedImages[image] = imageModel(images[image])
              }
            }
            dispatch({
              type: 'ATTACHMENTS_GET_SUCCESS',
              attachments: transformedImages
            })

            dispatch({
              type: 'AUCTION_IMAGES_GET_SUCCESS',
              auctionUuid: marketplaceFriendlyAuctionUuid,
              listings: event.data.listings,
              attachments: transformedImages
            })

            break
          }

          case 'SALE_INCREMENT_SET':
          case 'SALE_NEXT_BID_SET':
            // sale
            dispatch({
              type: 'LISTING_SALE_GET_SUCCESS',
              sale: parseSale(event.data.sale, isWebcast),
              // sale: parseSaleV2(
              //   getState(),
              //   event.data.bid.amount,
              //   event.data.sale,
              //   isWebcast
              // ),
              timestamp
            })
            break

          case 'WEBCAST_INPLAY_SET':
          case 'WEBCAST_INPLAY_STATE_SET':
          case 'WEBCAST_INPLAY_WARNING':
            // webcastInPlay
            dispatch({
              type: 'WEBCAST_INPLAY_GET_SUCCESS',
              inPlay: event.data,
              timestamp
            })
            break

          case 'WEBCAST_FEED_SET':
            // feed
            dispatch({
              type: 'MEDIA_FEED_GET_SUCCESS',
              feed: event.data,
              timestamp
            })
            break

          case 'WEBCAST_MESSAGE_SET':
            {
              // webcastMessage
              const message = Object.assign({}, event.data.message, {
                text: decodeEntities(event.data.message.text)
              })
              dispatch({
                type: 'WEBCAST_MESSAGE_GET_SUCCESS',
                auctionUuid: event.data.auctionUuid,
                message
              })
              if (
                message.popup &&
                message.text &&
                (!message.userUuid || message.userUuid === userUuid)
              ) {
                toast.info(message.text, {
                  autoClose: 30000
                })
              }
            }
            break

          case 'PONG':
            console.timeEnd('Ping Response Time')
            break

          default:
            console.warn('Received unrecognised event', event)
            break
        }

        return dispatch({
          type: 'WEBSOCKET_EVENT_SUCCESS',
          event
        })
      } catch (err) {
        dispatch({
          type: 'WEBSOCKET_EVENT_FAILED',
          event,
          err
        })
        throw err
      }
    }
  },
  auctionGet: (auctionUuid) => {
    return (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config
      dispatch({
        type: 'AUCTION_GET'
      })
      const isMarketplace = auctionUuid === 'marketplace'
      const auctionUrl = isMarketplace
        ? 'marketplace'
        : `auctions/${auctionUuid}`
      return APIRequest.get(apiBase, clientId, auctionUrl, null, 3)
        .then(async (res) => {
          const payload = isMarketplace ? res.body.marketplaceDetails : res.body
          const {
            listings,
            auction,
            registrants,
            saleInformation,
            configuration,
            categories,
            starredItems
          } = payload.information
          if (!auction) throw new Error('Auction not returned')

          const isWebcast = auction.webcast

          const partneredAuctions = isMarketplace ? res.body.uuids : null

          const resAttachments = payload.attachments
          // imageModel
          const attachments = {}
          for (const attachment in resAttachments) {
            if (
              Object.prototype.hasOwnProperty.call(resAttachments, attachment)
            ) {
              attachments[attachment] = imageModel(resAttachments[attachment])
            }
          }

          dispatch({
            type: 'AUCTION_GET_SUCCESS',
            auction: Object.assign({}, auction, {
              uuid: isMarketplace ? 'marketplace' : auction.uuid,
              activeListings: auction.activeListings.filter(listingUuid => listings[listingUuid].lotNumber !== '0')
            })
          })

          dispatch({
            type: 'ATTACHMENTS_GET_SUCCESS',
            attachments
          })

          dispatch({
            type: 'AUCTION_IMAGES_GET_SUCCESS',
            auctionUuid: auction.uuid,
            listings,
            attachments: attachments
          })

          const { bids, saleStatuses, sales, offers, maxBids } =
            payload.sellingInformation
          const { logoUuid } = auction

          // logo
          if (logoUuid) {
            dispatch({
              type: 'AUCTION_LOGO_GET_SUCCESS',
              auctionUuid,
              auctionLogo: logoUuid
            })
          }
          // partedAuctions
          if (partneredAuctions) {
            dispatch({
              type: 'PARTNERED_AUCTIONS_GET_SUCCESS',
              partneredAuctions
            })
          }

          // bid
          if (bids) {
            if (isWebcast) {
              for (const bid in bids) {
                if (Object.prototype.hasOwnProperty.call(bids, bid)) {
                  bids[bid] = parseBid(bids[bid], isWebcast)
                }
              }
            }
            dispatch({
              type: 'BIDS_GET_SUCCESS',
              bids
            })
          } else {
            dispatch({
              type: 'BIDS_GET_FAILED'
            })
            console.warn('bids not included')
          }

          // saleStatus
          if (saleStatuses) {
            dispatch({
              type: 'SALE_STATUSES_GET_SUCCESS',
              saleStatuses: saleStatuses
            })
          } else {
            dispatch({
              type: 'SALE_STATUSES_GET_FAILED'
            })
            console.warn('saleStatus not included')
          }

          // listings
          if (listings) {
            dispatch({
              type: 'LISTINGS_GET_SUCCESS',
              isMarketplace,
              listings,
              auctionUuid
            })
          } else {
            dispatch({
              type: 'LISTINGS_GET_FAILED'
            })
            console.warn('lots not included')
          }
          if (saleInformation) {
            const saleInformationWithLogo = Object.assign({}, saleInformation, {
              auctionLogo: get(auction, 'logoUuid'),
              locationLongitude: saleInformation.locationLongitude
                ? parseFloat(saleInformation.locationLongitude)
                : null,
              locationLatitude: saleInformation.locationLatitude
                ? parseFloat(saleInformation.locationLatitude)
                : null
            })
            dispatch({
              type: 'AUCTION_INFO_GET_SUCCESS',
              auctionUuid,
              information: saleInformationWithLogo
            })
          } else {
            console.warn('saleInformation not included')
            dispatch({
              type: 'AUCTION_INFO_GET_FAILED'
            })
          }
          if (registrants) {
            dispatch({
              type: 'REGISTRANTS_GET_SUCCESS',
              auctionUuid: auction.uuid,
              registrants
            })
          } else {
            dispatch({
              type: 'REGISTRANTS_GET_FAILED'
            })
            console.warn('registrants not included')
          }
          if (categories) {
            dispatch({
              type: 'CATEGORIES_GET_SUCCESS',
              auctionUuid,
              categories
            })
          } else {
            console.warn('categories not included')
          }
          if (starredItems) {
            dispatch({
              type: 'LISTING_FAVOURITES_GET_SUCCESS',
              auctionUuid,
              favourites: starredItems
            })
          }
          if (sales) {
            if (isWebcast) {
              for (const sale in sales) {
                if (Object.prototype.hasOwnProperty.call(sales, sale)) {
                  sales[sale] = parseSale(sales[sale], isWebcast)
                }
              }
            }
            // for (const sale in sales) {
            //   if (Object.prototype.hasOwnProperty.call(sales, sale)) {
            //     const currentBidValue = saleStatuses[sale].highestBidUuid ? bids[saleStatuses[sale].highestBidUuid].amount : sales[sale].nextBidValue
            //     sales[sale] = parseSaleV2(
            //       getState(),
            //       currentBidValue,
            //       sales[sale],
            //       isWebcast
            //     )
            //   }
            // }
            dispatch({
              type: 'LISTING_SALES_GET_SUCCESS',
              sales
            })
          } else {
            console.warn('sales not included')
          }

          if (offers) {
            dispatch({
              type: 'OFFERS_GET_SUCCESS',
              offers
            })
          }
          if (maxBids) {
            dispatch({
              type: 'MAX_BIDS_GET_SUCCESS',
              maxBids: Object.values(maxBids).reduce((acc, val) => {
                acc[val.uuid] = parseMaxBid(val, isWebcast)
                return acc
              }, {})
            })
          }

          if (configuration) {
            dispatch({
              type: 'AUCTION_CONFIG_GET_SUCCESS',
              auctionUuid: auctionUuid,
              configuration
            })
          }

          const webcast = payload.webcastInformation

          if (webcast) {
            const { inPlay, messages, feed } = webcast

            // feed
            if (feed) {
              dispatch({
                type: 'MEDIA_FEED_GET_SUCCESS',
                feed
              })
            }

            // inPlay
            if (inPlay) {
              dispatch({
                type: 'WEBCAST_INPLAY_GET_SUCCESS',
                inPlay
              })
            } else {
              dispatch({
                type: 'WEBCAST_INPLAY_GET_FAILED'
              })
              console.warn('inPlay not included')
            }

            // messages
            if (messages) {
              dispatch({
                type: 'WEBCAST_MESSAGES_GET_SUCCESS',
                auctionUuid: auction.uuid,
                messages
              })
            } else {
              dispatch({
                type: 'WEBCAST_MESSAGES_GET_FAILED'
              })
              console.warn('messages not included')
            }
          }

          if (isMarketplace) {
            return dispatch({
              type: 'AUCTION_GET_SUCCESS',
              auction: Object.assign({}, auction, {
                uuid: isMarketplace ? 'marketplace' : auction.uuid,
                activeListings: auction.activeListings.filter(listingUuid => listings[listingUuid].lotNumber !== '0')
              }),
              partneredAuctions,
              listings
            })
          }
        })
        .catch((err) => {
          console.error(err.message, err.status, err)
          dispatch({
            type: 'AUCTION_GET_FAILED',
            err
          })
          if (err.status === 503 || typeof err.status === 'undefined') {
            dispatch({
              type: 'GLOBAL_NOTIFICATION_ADDED',
              notificationType: 'danger',
              pageNeedsRefreshing: true,
              hasTimer: true,
              icon: faCircleExclamation,
              message: translate('JspPublicCodes_JSP_503_TOO_MANY_REQUESTS_ERROR')
            })
          }
          if (err.status !== 404 && err.status !== 503 && typeof err.status !== 'undefined') {
            dispatch({
              type: 'GLOBAL_NOTIFICATION_ADDED',
              notificationType: 'danger',
              pageNeedsRefreshing: true,
              icon: faCircleExclamation,
              message: translate(
                'JspPublicCodes_JSP_NETWORK_RECONNECTION_ERROR'
              )
            })
          }
          throw err
        })
    }
  },
  uuidGetById: (auctionId, itemId = null) => {
    return (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config
      dispatch({
        type: 'AUCTIONS_UUID_GET'
      })
      let url = `auctionUuid/${auctionId}`
      if (itemId) {
        url += `/${itemId}`
      }
      return APIRequest.get(apiBase, clientId, url)
        .then((res) => {
          const { auctionUuid, listingUuid } = res.body
          dispatch({
            type: 'AUCTIONS_UUID_GET_SUCCESS',
            auctionUuid,
            listingUuid
          })
          return {
            auctionUuid,
            listingUuid
          }
        })
        .catch((err) => {
          console.error(err)
          dispatch({
            type: 'AUCTIONS_UUID_GET_FAILED',
            err
          })
          throw err
        })
    }
  },
  saleIncrementsGet: (listingUuid) => {
    return async (dispatch, getState) => {
      dispatch({
        type: 'LISTING_SALE_GET_CUSTOM_INCREMENTS'
      })

      const userUuid = getState().users.user.uuid

      if (!userUuid || !listingUuid) {
        return dispatch({
          type: 'LISTING_SALE_GET_CUSTOM_INCREMENTS_FAILED'
        })
      }

      // const timestamp = new Date().getTime()
      const { apiBase, clientId } = getState().config.input.config
      const res = await APIRequest.get(apiBase, clientId, `bid/increments/${listingUuid}`)
      const resBody = res?.body || {}
      const increments = {}
      if (resBody?.increments) {
        // divide by 100, due to it always being in pence
        for (const key in resBody.increments) {
          if (Object.hasOwnProperty.call(resBody.increments, key)) {
            increments[key / 100] = resBody.increments[key] / 100
          }
        }
      }
      if (!increments) {
        dispatch({
          type: 'LISTING_SALE_GET_CUSTOM_INCREMENTS_FAILED'
        })
      }

      dispatch({
        type: 'LISTING_SALE_GET_CUSTOM_INCREMENTS_SUCCESS',
        increments,
        listingUuid
      })
    }
  }
}

export default auctions
